package com.tixforgigs.common.core.models.embed

import kotlinx.serialization.Serializable

@OptIn(ExperimentalJsExport::class)
@Serializable
class PostMessageEmbedHeightDTO(
  val height: Int
)